import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MyAccountAction from '../actions/MyAccountAction';
import ConfirmPayNow from '../../components/myaccount/ConfirmPayNow/ConfirmPayNow';

const mapStateToProps = state => ({
  customerInfo: state.myAccount.customerInfo,
  payNowError: state.myAccount.payNowError
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    checkSession: MyAccountAction.checkSession,
    submitPayNow: MyAccountAction.submitPayNow,
    clearAllDashboardNotifications: MyAccountAction.clearAllDashboardNotifications
  }, dispatch);


const ConfirmPayNowContainer = connect(mapStateToProps, mapDispatchToProps)(ConfirmPayNow);

export default ConfirmPayNowContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ConfirmPayNowContainer.js
 **/